export const UPDATE_CUSTOMER_LOGIN_EMAIL_FIELD = 'UPDATE_CUSTOMER_LOGIN_EMAIL_FIELD'
export const UPDATE_CUSTOMER_LOGIN_PASSWORD_FIELD = 'UPDATE_CUSTOMER_LOGIN_PASSWORD_FIELD'
export const RUN_CUSTOMER_LOGIN_FORM_VALIDATIONS = 'RUN_CUSTOMER_LOGIN_FORM_VALIDATIONS'
export const SHOW_CUSTOMER_LOGIN_FORM_VALIDATION_MESSAGE = 'SHOW_CUSTOMER_LOGIN_FORM_VALIDATION_MESSAGE'

export const SHOW_CUSTOMER_FORGOT_PASSWORD_MODAL = 'SHOW_CUSTOMER_FORGOT_PASSWORD_MODAL'
export const CLOSE_CUSTOMER_FORGOT_PASSWORD_MODAL = 'CLOSE_CUSTOMER_FORGOT_PASSWORD_MODAL'
export const UPDATE_CUSTOMER_FORGOT_PASSWORD_EMAIL_FIELD = 'UPDATE_CUSTOMER_FORGOT_PASSWORD_EMAIL_FIELD'
export const SHOW_INSTRUCTIONS_SENT_MESSAGE = 'SHOW_INSTRUCTIONS_SENT_MESSAGE'

export const SHOW_ACCOUNT_NAME = 'SHOW_ACCOUNT_NAME'
export const CUSTOMER_ACCOUNT_LOGOUT = 'CUSTOMER_ACCOUNT_LOGOUT'
export const CUSTOMER_ACCOUNT_LOGIN = 'CUSTOMER_ACCOUNT_LOGIN'

export const EMAIL_EXISTS_STATUS = 'EMAIL_EXISTS_STATUS'
export const EMAIL_STATUS_VERIFYING = 'EMAIL_STATUS_VERIFYING'

export const CHANGE_EMAIL = 'CHANGE_EMAIL'
export const CHANGE_PASSWORD_ACCOUNT_INFO = 'CHANGE_PASSWORD_ACCOUNT_INFO'
export const SHOW_PASSWORD_ERROR = 'SHOW_PASSWORD_ERROR'
export const CUSTOMER_ALREADY_LOGIN = 'CUSTOMER_ALREADY_LOGIN'

export const RESET_FORM_FEILDS = 'RESET_FORM_FEILDS'
export const RESET_FORGETPWD_FEILDS = 'RESET_FORGETPWD_FEILDS'
export const SET_COUNTRIES = 'SET_COUNTRIES'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_USER_LOGIN = 'SET_USER_LOGIN'
export const SET_USER_NAME = 'SET_USER_NAME'
export const SET_SELECTED_COUNTRY = 'SET_SELECTED_COUNTRY'
export const SET_USER_DEFAULT_EMAIL = 'SET_USER_DEFAULT_EMAIL'
